export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40410a322b258c65efccc505b42fe2e2232840bf0d&name=revalidateCommunity!'